/**
 * Create a shallow copy of an object flattening nested
 * objects one level deep.
 */
export function flattenObj(obj) {
  return Object.fromEntries(
    Object.entries(obj)
      .reduce((a, [k, v]) => [
        ...a,
        ...(typeof v === 'object' && v !== null
          ? Object.entries(v)
          : [[k, v]])
      ], [])
  );
}

/**
 * Create a shallow copy of an object including only the properties
 * specified by "keys".
 */
export function pick(obj, keys) {
  return Object.fromEntries(
    Object.entries(obj).filter(([k]) => keys.includes(k))
  );
}

/**
 * Check whether an object contains properties with the specified keys.
 * @param {Object} obj The object to test.
 * @param {Array} props An array of prop keys to check for.
 * @returns True if obj contains all of the specified prop keys.
 */
export function hasProps(obj, props) {
  const keys = Object.keys(obj || {});
  return Array.from(props || []).every(p => keys.includes(p));
}

/**
 * Creates a shallow copy of an object excluding the properties
 * specificed by {@link keys}.
 * @param {Object} obj The object.
 * @param  {string[]} keys The keys of the properties to omit.
 * @returns A shallow copy of the object.
 */
export function omit(obj, keys) {
  return Object.fromEntries(
    Object.entries(obj).filter(([k]) => !keys.includes(k))
  );
}
